<template>
  <a-form :form="pageForm" class="page-content">
    <div class="form-content">
      <a-form-item
        v-if="pItemData.id"
        label="上及类别名称"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          disabled
          v-decorator="[
            'parent',
            {
              initialValue:  pItemData.name
            }
          ]"
        />
      </a-form-item>
      <!-- <a-form-item
        v-if="pItemData.id"
        :style="{
          margin: '0px auto 10px',
          width: '80%',
          height: '0px',
          'border-bottom': '1px solid #dcdcdc'
        }"
      ></a-form-item> -->

      <a-form-item
        label="名称"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
			placeholder="请输入类别名称"
          v-decorator="[
            'name',
            {
              initialValue: formData.name,
              rules: [{ required: true, message: '请输入类别名称' }]
            }
          ]"
        />
      </a-form-item>
 <a-form-item
        label="是否启用"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
       <a-radio-group
         v-decorator="[
           'status',
           { rules: [{ required: true, message: '请选择状态' }],initialValue:formData.status }
         ]"
       >
         <a-radio :value="1">
           启用
         </a-radio>
         <a-radio :value="2">
           停用
         </a-radio>
       </a-radio-group>
      </a-form-item>

    </div>
    <div class="divider-land"></div>
    <a-form-item style="text-align:center;">
      <a-button
        style="margin-right:20px; width:100px;"
        @click.stop="cancelForm"
      >
        取 消
      </a-button>
      <a-button type="primary" style="width:100px;" @click.stop="submitForm">
        {{ submitBtnLabel }}
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
var pageContext;
export default {
  props: {
    submitBtnLabel: {
      type: String,
      default: () => {
        return "新 增";
      }
    },
    platform_type: {
      type: String,
      default: () => {
        return "cp";
      }
    },
    pItemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    layerid: {
      type: String,
      default: ""
    },
    lydata: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  beforeCreate() {
    pageContext = this;
    pageContext.pageForm = pageContext.$form.createForm(pageContext, {
      onValuesChange: function(props, values) {
        let key = Object.keys(values)[0];
        pageContext.formData[key] = values[key];
      }
    });
  },
  data() {
    return {
      formData: pageContext.initFormData()
    };
  },
  mounted() {
    console.log(pageContext.platform_type);
  },
  methods: {
    initFormData() {
      //编辑权限菜单
      if (pageContext.itemData.id) {
        return {
          id: pageContext.itemData.id,
          // icon: pageContext.itemData.icon,
          name: pageContext.itemData.name,
		   status: pageContext.itemData.status,
          // url: pageContext.itemData.url,
          // sort: pageContext.itemData.sort
        };
      }
      //新增下级权限菜单
      else if (pageContext.pItemData.id) {
        return {
          pid: pageContext.pItemData.id,
          // path: pageContext.pItemData.path + pageContext.pItemData.id + ",",
          // platform_type: pageContext.pItemData.platform_type,
          // icon: "",
          name: "",
		  status:1,
          // url: "",
          // sort: 100
        };
      }
      //新增顶级权限菜单
      else {
        return {
          pid: "0",
          // path: "0,",
          // platform_type: pageContext.platform_type,
          // icon: "",
          name: "",
          // url: "",
		  status:1,
          // sort: 100
        };
      }
    },
    async submitForm() {
      let result = false;
      pageContext.pageForm.validateFields((errors, values) => {
        result = errors !== null;
      });
      if (result) {
        pageContext.$message.error("请检查表单");
        return;
      }

      pageContext.$http
        .post("/paperCategory/edit", pageContext.formData)
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$parent.refreshDataList();
            pageContext.$message.success(response.data.msg);
            pageContext.$layer.close(pageContext.layerid);
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查1");
          console.log(error);
        });
    },
    cancelForm() {
      pageContext.$layer.close(pageContext.layerid);
      pageContext.$message.info("操作取消！");
    }
  }
};
</script>
<style scoped lang="scss">
.page-content {
  width: 100%;

  .form-content {
    width: 95%;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .divider-land {
    background-color: #dcdcdc;
    height: 1px;
    width: 80%;
    margin: 10px auto;
  }
}
</style>
